import type { ParcelTerminal } from '@/domain/Parcel';
import { api } from '@/lib/api';
import { mutationOptions } from '@tanstack/react-query';
import { toast } from 'sonner';
import { mutationKeys } from '../mutationKeys';

export interface CreateCheckoutRequest {
  cart_id: number;
  address_id?: number;
  package: 'Single';
  promo_code?: string;
  terminal?: ParcelTerminal;
}

export interface CheckoutResponse {
  data: {
    url: string;
  };
}

export const createCheckoutMutation = mutationOptions({
  mutationKey: mutationKeys.checkout.create(),
  mutationFn: async (values: CreateCheckoutRequest) =>
    api.post('checkout', { json: values }).json<CheckoutResponse>(),
  onSuccess: (data) => {
    if (data.data.url) {
      window.location.href = data.data.url;
    }
  },
  onError: (error) => {
    toast.error(error.message || 'Failed to create checkout');
  },
});
